import { Typography } from '@tvg/fuse/typography';
import classNames from 'classnames';
import React from 'react';
import styles from './AccordionButton.module.css';

export interface AccordionButtonProps extends React.ButtonHTMLAttributes<HTMLDivElement> {}

export const AccordionButton = React.forwardRef<HTMLDivElement, AccordionButtonProps>(
  ({ className, ...props }, ref) => (
    <div role="button" className={classNames(styles.accordionButton, className)} {...props} ref={ref} tabIndex={0}>
      <Typography data-testid="fuse-accordion__heading" type="heading" size="1" tag="h2">
        {props.children}
      </Typography>
    </div>
  ),
);
AccordionButton.displayName = 'AccordionButton';
